import React from 'react';

import purpleStar from './StarIcon/images/purpleStar@2x.jpg';
import { desktopOnly, mobileOnly } from 'styles/mixins/displayMobileDesktop';

const FiveStars = () => {
  const numArray = [1, 2, 3, 4, 5];
  const starProps = (width: number) => ({
    alt: '',
    src: purpleStar,
    style: {
      width,
      marginRight: '2px',
    },
  });

  return (
    <div
      style={{
        display: 'inline-flex',
      }}
    >
      {numArray.map((index) => (
        <React.Fragment key={index}>
          <img css={mobileOnly('block', 'xlUp')} {...starProps(16)} />
          <img css={desktopOnly('block', 'xlUp')} {...starProps(24)} />
        </React.Fragment>
      ))}
    </div>
  );
};

export default FiveStars;
